export default "__VITE_ASSET__ffca8831__"